import React from "react";
import RecentAlerts from "./components/recentAlerts";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
function Alerts() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <RecentAlerts />
      </MDBox>
    </DashboardLayout>
  );
}

export default Alerts;
